import { call, takeEvery, select, put } from "redux-saga/effects"
import { createReducer } from "reduxsauce"
import { Creators as notificationCreators } from "modules/notifications/model"
import actionCreator from "helpers/actionCreator"
import { log } from "helpers/logger"
import { del } from "api"

export const { Types, Creators } = actionCreator("ompnt/modules/staticAlert", {
  setStaticAlert: ["staticAlert"],
  removeStaticAlert: [],
  setNewVersion: ["time"],
})

const DEFAULT_STATE = {
  staticAlert: null,
  newVersionTime: null,
}

function handleSetStaticAlert(state, { staticAlert }) {
  return { ...state, staticAlert: staticAlert || null }
}

function handleRemoveStaticAlert(state) {
  return { ...state, staticAlert: null }
}

function handleSetNewVersion(state, { time }) {
  return { ...state, newVersionTime: time }
}

export default createReducer(DEFAULT_STATE, {
  [Types.SET_STATIC_ALERT]: handleSetStaticAlert,
  [Types.REMOVE_STATIC_ALERT]: handleRemoveStaticAlert,
  [Types.SET_NEW_VERSION]: handleSetNewVersion,
})

export function getAccount(state) {
  return state.global.selected.account
}

export function* startRemoveStaticAlert() {
  try {
    const account = yield select(getAccount)
    const staticAlert = yield call(del, `/api/${account}/alerts`)
    yield put(Creators.setStaticAlert(staticAlert))
  } catch (error) {
    yield call(log, error)
    yield put(notificationCreators.add("error", null, "An unexpected error occurred while trying to remove the notification."))
  }
}

export function* saga() {
  yield takeEvery(Types.REMOVE_STATIC_ALERT, startRemoveStaticAlert)
}
